const HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const URL_REGEX = /(https?:\/\/[^\s]*)/g;

export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (ch) => HTML_ESCAPE_MAP[ch]);
}

function escapeHref(url: string): string {
  return url.replace(/[<>"']/g, (ch) => HTML_ESCAPE_MAP[ch]);
}

export function escapeAndLinkify(text: string): string {
  if (!text) return '';

  let result = '';
  let lastIndex = 0;
  const re = new RegExp(URL_REGEX.source, 'g');
  let match: RegExpExecArray | null;

  while ((match = re.exec(text)) !== null) {
    result += escapeHtml(text.slice(lastIndex, match.index));
    const url = match[0];
    result += `<a class="highlights" href="${escapeHref(url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(url)}</a>`;
    lastIndex = re.lastIndex;
  }

  result += escapeHtml(text.slice(lastIndex));
  return result;
}
